import React from 'react';

function Chat() {
  return (
    <section className="tc-chat-style1" id='contact'>
      <div className="container">
        <div className="content">
          <a href="mailto:afthab98950@gmail.com" target='_blank' className="xl-text">
           afthab98950@gmail.com
          </a>
          <a href="https://wa.me/9895096500" target='_blank' className="xl-text">
          +91 989 509 6500
          </a>
          <h5 className="mb-50 lh-5">
            Let us help your dream <br /> become reality
          </h5>
        </div>
      </div>
      <img src="/home1/assets/img/c_line4.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Chat;
